function generateWidget(npi, version) {
    if (typeof (BFWidget) != 'undefined') {
        BFWidget.config({
            "appId": pressGaneyAppId,
            "personId": npi,
            "version": version,
            "page": "1",
            "perPage": "50",
            "noOfDays": "365",
            "minSurveyCount": "1",
            "minRatingCount": "0",
            "minWordCount": "0",
            "minThreshold": "0.0",
            "optionalParams": {
                "displayDiv": "bf-bsr-comments-" + npi,
                "summaryTitleFontStyle": "Lato",
                "summaryTitleFontSize": "24",
                "summaryTitleFontColor": "#000000",
                "overallSatisfactionFontStyle": "Lato",
                "overallSatisfactionFontSize": "13",
                "overallSatisfactionColor": "#000000",
                "summaryStarRatingColor": "#f8af13",
                "summaryStarRatingSize": "17",
                "overallRatingFontStyle": "Lato",
                "overallRatingFontColor": "#000000",
                "overallRatingFontSize": "13",
                "overallRatingFontStyleNumerical": "Lato",
                "overallstarratingcolorNumerical": "#000000",
                "overallRatingFontSizeNumerical": "13.5",
                "totalRatingFontSize": "13",
                "totalRatingFontColor": "#000000",
                "totalRatingFontStyle": "Lato",
                "totalCommentsFontStyle": "Lato",
                "totalCommentsFontSize": "13",
                "totalCommentsFontColor": "#000000",
                "questionBreakdownTitleFontStyle": "Lato",
                "questionBreakdownTitleFontSize": "24",
                "questionBreakdownTitleFontColor": "#000000",
                "questionStarRatingScoreFontSize": "13.5",
                "questionStarRatingScoreFontColor": "#000000",
                "questionStarRatingScoreFontStyle": "Lato",
                "surveyQuestionsFontSize": "13.5",
                "surveyQuestionsFontColor": "#000000",
                "surveyQuestionsFontStyle": "Lato",
                "questionStarRatingStarFontColor": "#f8af13",
                "questionStarRatingStarFontSize": "17",
                "commentsTitleFontSize": "24",
                "commentsTitleFontColor": "#000000",
                "commentsTitleFontStyle": "Lato",
                "overallPerformanceSummaryFontSize": "13",
                "overallPerformanceSummaryFontColor": "#000000",
                "overallPerformanceSummaryFontStyle": "Lato",
                "dateFontSize": "11",
                "dateFontColor": "#000000",
                "dateFontStyle": "Lato",
                "commentsFontSize": "13",
                "commentsFontColor": "#000000",
                "commentsFontStyle": "Lato",
                "starRatingCommentColor": "#f8af13",
                "starRatingCommentSize": "17",
                "viewMoreFontSize": "13",
                "viewMoreFontColor": "#000000",
                "viewMoreFontStyle": "Lato"
            }
        });
    }
}

// Helper function to delay execution
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

async function generateWidgetsWithDelay(items) {
    for (let item of items) {

        //  hide the no review div
        var targetNode = document.getElementById("bf-bsr-comments-" + item.npi);

        var config = { childList: true, subtree: true };
        var callback = function (mutationsList, observer) {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    targetNode.querySelectorAll('div,p').forEach(element => {
                        if (element.innerHTML.includes('Sorry, no reviews found!')) {
                            element.style.display = 'none';
                        }
                        observer.disconnect();
                    });

                }
            }
        };

        var observer = new MutationObserver(callback);
        observer.observe(targetNode, config);

        generateWidget(item.npi, item.version);

        await delay(3000); // Wait 3 seconds before generating the next widget
    }
}

$(document).ready(function () {

    loadScript(() => {

        let ratingItems = document.querySelectorAll('.gh-med-rating div.bf-widget');

        // Collect items with NPI and version
        let items = [];
        for (let i = 0; i < ratingItems.length; i++) {
            let element = ratingItems[i];
            items.push({
                npi: element.getAttribute('data-ds-id'),
                version: element.getAttribute('data-ds-version') || "2" // Default to version 2 if not specified
            });
        }

        // Generate widgets with delay
        generateWidgetsWithDelay(items);

    });






});
